import {useField} from 'formik';
import React, { useState } from 'react';
import ZsFormikSelect from "src/components/atoms/zsSelect";
import type {PossibleContract} from "./form";

function maskContractNumber(lastTwoDigits: string) {
  return '********' + lastTwoDigits;
}

export interface IContractSelectionProps {
    data: PossibleContract[];
    type: string;
    name: string;
}

export function ContractSelection(props: IContractSelectionProps) {

    const [{value}, __, {setValue}] = useField({name: props.name});

    const [selectValues, setSelectValues] = useState<any[]>([]);

    React.useEffect(() => {
      if (props.data && props.data.length > 0 && selectValues.length === 0) {
          const values = [];
          for (const contract of props.data) {
              if (contract.verbrauchsart === props.type) {
                  values.push({
                    value: contract.vertragsnummerVerschleiert,
                    label: maskContractNumber(contract.vertragsnummerLetzteZweiZiffern),
                    istIMS: contract.istIMS
                  })
              }
          }
          if (values.length > 0) {
              setValue(values[0].value);
          }
          setSelectValues(values);

      }
        }, [props.data, props.type, selectValues, setValue]);

    return (
        <>
            <label><span
                style={{color: '#F00'}}>*</span> Ihre Vertragsnummer endet auf</label>
            {selectValues && selectValues.length > 0 && (<ZsFormikSelect name={props.name} data={selectValues} disabled={selectValues.length === 1}/>)}
        </>
    );

}